export default __webpack_public_path__ + "static/BasierCircle-BoldItalic-f914f7134dda577a13a62a564b8beaf4.woff2";